export default {
  state: {
    datasets: {
      data: [],
      search: '',
      page: 1,
      totalPages: 1,
      sort: {
        name: 1
      }
    }
  },
  getters: {

  },
  mutations: {

  },
  actions: {
    fetchClientDataset ({commit, rootState}, payload) {
      return rootState.services.datasets
        .get(payload.id)
    },
    fetchClientTimespans ({commit, rootState}, payload) {
      return rootState.services.datasets
        .find({
          query: {
            clientID: payload.id,
            $select: ['year', 'quarter', 'approved', 'minimal', 'minimalLite'],
            $sort: {
              year: -1,
              quarter: -1
            },
            paginate: false
          }
        })
    },
    updateDataset ({commit, rootState}, payload) {
      commit('setLoading', true)
      // console.log(payload)
      rootState.services.datasets.patch(payload._id, payload)
        .then(res => {
          commit('setLoading', false)
        })
        .catch(err => {
          console.log(err)
        })
    },
    saveDataset ({commit, rootState}, payload) {
      commit('setLoading', true)
      rootState.services.datasets.create(payload)
        .then(res => {
          commit('setLoading', false)
        })
        .catch(err => {
          console.log(err)
        })
    },
    deleteDataset ({commit, rootState}, payload) {
      commit('setLoading', true)
      rootState.services.datasets.remove(payload)
        .then(res => {
          commit('setLoading', false)
        })
        .catch(err => {
          console.log(err)
        })
    },
    approveDataset ({commit, rootState}, payload) {
      commit('setLoading', true)
      rootState.services.datasets.patch(payload, {approved: true})
        .then(res => {
          commit('setLoading', false)
        })
        .catch(err => {
          console.log(err)
        })
    },
    disapproveDataset ({commit, rootState}, payload) {
      commit('setLoading', true)
      rootState.services.datasets.patch(payload, {approved: false})
        .then(res => {
          commit('setLoading', false)
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/datasets.js